// src/utils/Request.utils.js
import axios from 'axios';
import { jwtDecode as jwt_decode } from "jwt-decode";
import jsonp from 'jsonp';
//import * as ReactDOM from 'react-dom';

import SessionStorage from './SessionStorage.utils';
import { nvl, nvlNumber } from "./Common.utils";
import { getAuthHeaders } from "./auth";
import { redirectToLogin } from "./AdminAuth.utils";
//import LoadingBar from './LoadingBar';

//import CryptoJS from 'crypto-js';
import 'whatwg-fetch'

import moment from 'moment';

//import { socket, SOCKET_EVENT } from "./socket";

moment.locale('ko-KR');

//const local = ['localhost', '127.0.0.1'].some((d) => d === window.location.hostname);

//let protocol = window.location.protocol;
//let hostname = window.location.hostname;
//let port = window.location.port === '80' || window.location.port === '443' || window.location.port === '' ? '' : ":" + window.location.port;

let redirectUrl = process.env.REACT_APP_WEB_URL + "/...."; // 외부 api 사용 때 redirect 필요 시 사용
let base = process.env.REACT_APP_API_URL; // api 주소

console.log('base', base)

// added by psk 20230328 - page 이동 시 이전 요청 모두 끊을 때 사용
const source = axios.CancelToken.source();
const requestInstance = axios.create();

const adminSession = SessionStorage.getItemJsonParse("adminSession");

//const adminSession = SessionStorage.getItemJsonParse("adminSession");
// console.log("토큰 확인 : " + nvl(adminSession?.refreshToken))

// ── access token 자동 갱신 ────────────────────────────────────────────
// access token 만료로 401 을 받으면 곧바로 로그아웃시키지 않고, refresh token 으로
// 재발급받아 실패한 요청을 그대로 재시도한다.
// 재발급까지 실패하면 원래 401 을 그대로 흘려보내 기존 오류 처리(processError)로 넘긴다.
// 단 서버가 재발급을 거부했다면(refresh token 만료 등) 다시 로그인해야만 풀리므로 로그인 화면으로 보낸다.

// 인터셉터를 타지 않는 별도 인스턴스. requestInstance 로 부르면 갱신 요청이 낸 401 이
// 다시 인터셉터로 들어와 무한 루프가 된다.
const refreshInstance = axios.create();

// 401 이 동시에 여러 건 터져도 재발급은 한 번만 하고 나머지는 그 결과를 함께 기다린다
let refreshPromise = null;

/**
 * refresh token 으로 access token 을 재발급받아 저장한다.
 * @returns {Promise<{accessToken?: string, rejected?: boolean}|null>} 성공하면 { accessToken },
 *   서버가 거부하면 { rejected: true }, 저장된 토큰이 없어 시도하지 않았으면 null
 */
const refreshAccessToken = async () => {
  const session = SessionStorage.getItemJsonParse("adminSession");

  if (nvl(session?.accessToken) === "" || nvl(session?.refreshToken) === "") return null;

  // 서버는 access token 이 만료 상태일 때만 새 토큰을 내려준다 (아직 유효하면 202)
  // 다른 요청과 같은 헤더 구성을 쓴다. 게이트웨이 서명(x-awapp-apigw-*)이 빠지면 앞단에서 막힐 수 있다.
  // getAuthHeaders 가 세션에서 읽는 accessToken 이 곧 위에서 확인한 그 토큰이다.
  const response = await refreshInstance.put(
    `${base}/admin/token/refresh`,
    { refresh: session.refreshToken },
    { timeout: 10000, headers: getAuthHeaders() }
  );

  // 서버는 access token 이 'jwt expired' 일 때만 재발급한다.
  // 서명 불일치·형식 오류처럼 만료가 아닌 실패는 202(갱신 불필요)로 떨어져 갱신할 방법이 없다.
  if (response?.data?.messageCode === 202) {
    console.warn('서버가 토큰 갱신을 거부했습니다(202). access token 이 만료 상태가 아닙니다 - 서명 불일치이거나 다른 환경에서 발급된 토큰일 수 있습니다.');

    return { rejected: true };
  }

  const accessToken = response?.data?.data?.accessToken;

  if (response?.data?.messageCode !== 200 || nvl(accessToken) === "") {
    console.warn('access token 재발급 실패 - 응답 코드:', response?.status, '봉투 코드:', response?.data?.messageCode);

    return { rejected: true };
  }

  SessionStorage.setItem("adminSession", "accessToken", accessToken);
  SessionStorage.setItem("adminSession", "refreshToken", nvl(response.data.data.refreshToken) !== "" ? response.data.data.refreshToken : session.refreshToken);

  return { accessToken };
}

/** 진행 중인 재발급이 있으면 그 결과를 공유한다. */
const ensureAccessToken = () => {
  if (!refreshPromise) {
    refreshPromise = refreshAccessToken()
      .catch((error) => {
        // refresh token 도 만료됐거나 네트워크 오류 - 재시도로는 풀 수 없으므로 원래 401 을 흘려보낸다
        console.warn('access token 재발급 실패:', nvl(error?.response?.status) || error?.message);

        // 401·400 은 서버가 refresh token 을 거부한 것이라 다시 로그인해야 한다.
        // 네트워크·서버 오류는 일시적일 수 있어 로그인 정보를 지우지 않는다
        const status = error?.response?.status;

        return status === 401 || status === 400 ? { rejected: true } : null;
      })
      .finally(() => {
        refreshPromise = null;
      });
  }

  return refreshPromise;
}

/** 이 요청이 실제로 보낸 access token (axios 1.x 는 AxiosHeaders 인스턴스를 넘긴다) */
const requestedAccessTokenOf = (config) => {
  const authorization = typeof config.headers?.get === 'function' ? config.headers.get('Authorization') : config.headers?.Authorization;

  return nvl(authorization).replace('Bearer ', '');
}

requestInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error?.config;

    // 재시도분이 또 401 이면 재발급으로 풀 수 있는 문제가 아니므로 기존 401 처리로 넘긴다
    if (error?.response?.status !== 401 || !config || config.isTokenRetry) return Promise.reject(error);

    const storedAccessToken = nvl(SessionStorage.getItemJsonParse("adminSession")?.accessToken);
    const requestedAccessToken = requestedAccessTokenOf(config);

    // 이 요청이 나간 뒤 다른 요청이 이미 갱신을 끝냈다면, 재발급 없이 새 토큰으로 바로 재시도한다.
    // (여기서 다시 재발급을 걸면 서버가 202 로 거부해 이 요청만 로그아웃된다)
    // 단 요청 토큰을 못 읽었으면 갱신 여부를 판단할 수 없으므로 반드시 재발급을 거친다.
    const isAlreadyRefreshed = requestedAccessToken !== "" && storedAccessToken !== "" && storedAccessToken !== requestedAccessToken;
    const refreshed = isAlreadyRefreshed ? { accessToken: storedAccessToken } : await ensureAccessToken();

    // 서버가 재발급을 거부했다면 로그인 화면으로 보낸다. 화면이 바뀌므로 오류 처리(경고창 등)는 띄우지 않게 응답을 보류한다.
    // 이미 로그인 화면이면 이동하지 않으므로 원래 401 을 기존 오류 처리로 넘긴다
    if (refreshed?.rejected && redirectToLogin()) return new Promise(() => {});

    const accessToken = nvl(refreshed?.accessToken);

    if (accessToken === "") return Promise.reject(error);

    // axiosConfig 는 모듈 전역 공유 객체라 그대로 재사용하면 params·headers 가 섞인다.
    // 실패한 요청의 설정을 복제해 Authorization 만 새 토큰으로 바꿔 재요청한다.
    const retryConfig = {
      ...config,
      isTokenRetry: true,
      headers: {
        ...(typeof config.headers?.toJSON === 'function' ? config.headers.toJSON() : config.headers),
        Authorization: `Bearer ${accessToken}`
      }
    };

    return requestInstance.request(retryConfig);
  }
);

// requestInstance.interceptors.request.use(
//   config => {
//     // setLoading(true);

//     // ReactDOM.render(<LoadingBar type={"spin"} color={"#FFFFFF"} active={true} />, document.getElementById("root"));

//     return config;
//   },
//   error => {
//     // setLoading(false);

//     return Promise.reject(error)
//   }
// );

// requestInstance.interceptors.response.use(
//   response => {
//     // setLoading(false);

//     // ReactDOM.render(<LoadingBar type={"spin"} color={"#FFFFFF"} active={false} />, document.getElementById("root"));

//     return response;
//   },
//   error => {
//     // setLoading(false);

//     return Promise.reject(error)
//   }
// );



// const calculateRFC2104HMAC = (data, key) => {
//   const rawHmac = CryptoJS.HmacSHA256(CryptoJS.enc.Utf8.parse(data), CryptoJS.enc.Utf8.parse(key));
//   return CryptoJS.enc.Base64.stringify(rawHmac);
// }


// function getNonKey()
// {
//   // const hashkey = CryptoJS.SHA256(Date.now()+'5E41A022A7BBB79874645GCFGK5F5A42FC6A43D837DCC94139DDCB29AE35C2B5').toString();
//   //   return btoa(hashkey);
//   const hashkey = calculateRFC2104HMAC(Date.now(), '5E41A022A7BBB79874645GCFGK5F5A42FC6A43D837DCC94139DDCB29AE35C2B5');
//   return hashkey;
// }

const axiosConfig = {
  timeout: 5000,
  withCredentials: false,
  headers: getAuthHeaders(),
  cancelToken: source.token
};

// const axiosConfig = getAuthHeaders();

// ---------------------------------------------

const axiosMultipartConfig = {
  timeout: 5000,
  withCredentials: false,
  headers: {
    "Authorization": `Bearer ${nvl(adminSession?.accessToken)}`,
    "content-type": "multipart/form-data; charset=UTF-8"
  },
  cancelToken: source.token
};

const getMultipartConfig = () => {
  const headers = getAuthHeaders();
  delete headers["Content-Type"];

  return {
    ...axiosMultipartConfig,
    headers,
  };
};

const getBase = () => {
  return base;
}

const getRedirectUrl = () => {
  return redirectUrl;
}

const currentTimeStamp = () => {
  return Date.now().toString();
}

const processSuccess = (response, successHandler) => {
  if (successHandler && typeof successHandler === 'function') {
    try {
      successHandler(response.data);
    } catch (e) {
      console.error(e);
      alert('스크립트 동작 중 오류가 발생했습니다.');
    }
  }
}

// 서버가 클라이언트 귀책 오류를 실제 HTTP 4xx 로 내려주기 시작하면서(DEV-2440),
// axios 는 이 응답을 reject 로 흘린다. 그런데 화면 코드는 successHandler 안에서
// response.messageCode 로 분기하도록 짜여 있다.
//
// 응답 본문이 기존과 동일한 봉투({messageCode, messageString, data})이면
// successHandler 로 그대로 넘겨 기존 흐름을 유지한다. HTTP 상태만 진실해진다.
// 401 은 제외한다 — 진짜 인증 실패는 기존 오류 경로로 가야 한다.
const isEnvelopeResponse = (error) => {
  const data = error?.response?.data;

  if (error?.response?.status === 401) return false;
  if (!data || typeof data !== 'object') return false;

  return typeof data.messageCode === 'number';
};

const processError = (error, failHandler, goPrecessError, successHandler) => {
  if (successHandler && isEnvelopeResponse(error)) {
    return processSuccess(error.response, successHandler);
  }

  console.debug(error)

  if (!error.response || !error.response.status) console.error('NETWORK ERROR');
  else if (failHandler && typeof failHandler === 'function' && !goPrecessError) failHandler(error, error.response);
  else if (error && error.response) {
    if (goPrecessError && failHandler && typeof failHandler === 'function') failHandler(error, error.response);

    // 프록시가 HTML 오류 페이지를 돌려주면 data 가 문자열이라 .messageCode 접근에서 터진다.
    switch (error.response.data?.messageCode) {
      case 400: {
        console.error('요청이 올바르지 않습니다.');
        console.log(error.response.data);

        break;
      }

      case 401: {
        console.error('인증 필요');

        break;
      }

      case 404: {
        console.error('404 NOT FOUND');

        break;
      }

      case 409: {
        console.error('이미 존재하는 값. 중복된 내용이 있는지 확인필요');

        break;
      }

      default: {
        console.error('오류');

        break;
      }
    }
  } else {
    console.error('알 수 없는 오류가 발생했습니다.');
  }
}

const afterRequest = () => {
  // console.log("응답 받고 실행~!! 끝");
}

const get = async (uri, params, successHandler, failHandler, goPrecessError, useBase64Auth = false) => {
  axiosConfig.headers = getAuthHeaders()
  axiosConfig.params = params;
  return requestInstance
    .get(`${base}${uri}`, axiosConfig)
    .then((response) => {
      processSuccess(response, successHandler);
    })
    .catch((error) => {
      processError(error, failHandler, goPrecessError, successHandler);
    })
    .finally(() => {
      afterRequest();
    });
}

const post = async (uri, params, successHandler, failHandler, goPrecessError, useBase64Auth = false) => {
  axiosConfig.headers = getAuthHeaders()
  delete axiosConfig.params;
  return requestInstance
    .post(`${base}${uri}`, params, axiosConfig)
    .then((response) => {
      console.log('>>POST::socket.emit(dashboard)');
      //socket.emit('dashboard', {room:1, name:'react' });
      processSuccess(response, successHandler);
    })
    .catch((error) => {
      processError(error, failHandler, goPrecessError, successHandler);
    })
    .finally(() => {
      afterRequest();
    });
}

// 첨부 파일용
const postMultipart = async (uri, params, successHandler, failHandler, goPrecessError, useBase64Auth = false) => {
  delete axiosConfig.params;
  return requestInstance
    .post(`${base}${uri}`, params, getMultipartConfig())
    .then((response) => {
      processSuccess(response, successHandler);
    })
    .catch((error) => {
      processError(error, failHandler, goPrecessError, successHandler);
    })
    .finally(() => {
      afterRequest();
    });
}

const put = async (uri, params, successHandler, failHandler, goPrecessError, useBase64Auth = false) => {
  axiosConfig.headers = getAuthHeaders()
  delete axiosConfig.params;
  return requestInstance
    .put(`${base}${uri}`, params, axiosConfig)
    .then((response) => {
      console.log(response)
      console.log('>>PUT::socket.emit(dashboard)');
      //socket.emit('dashboard', {room:1, name:'react' });
      processSuccess(response, successHandler);
    })
    .catch((error) => {
      processError(error, failHandler, goPrecessError, successHandler);
    })
    .finally(() => {
      afterRequest();
    });
}

const patch = async (uri, params, successHandler, failHandler, goPrecessError, useBase64Auth = false) => {
  axiosConfig.headers = getAuthHeaders()
  delete axiosConfig.params;
  return requestInstance
    .patch(`${base}${uri}`, params, axiosConfig)
    .then((response) => {
      console.log('>>PATCH::socket.emit(dashboard)');
      //socket.emit('dashboard', {room:1, name:'react' });
      processSuccess(response, successHandler);
    })
    .catch((error) => {
      processError(error, failHandler, goPrecessError, successHandler);
    })
    .finally(() => {
      afterRequest();
    });
}

const del = async (uri, params, successHandler, failHandler, goPrecessError, useBase64Auth = false) => {
  axiosConfig.headers = getAuthHeaders()
  delete axiosConfig.params;
  return requestInstance
    .delete(`${base}${uri}`, { data: params, ...axiosConfig })
    .then((response) => {
      console.log('>>DEL::socket.emit(dashboard)');
      //socket.emit('dashboard', {room:1, name:'react' });
      processSuccess(response, successHandler);
    })
    .catch((error) => {
      processError(error, failHandler, goPrecessError, successHandler);
    })
    .finally(() => {
      afterRequest();
    });
}


// added by psk 20230502 - jsonp 추가
const jsonpFunc = async (uri, callback, successHandler) => {
  jsonp(uri, { name: callback }, (error, response) => {
    if (error) processError(error);
    else successHandler(response)
  });
}

// added by psk 20230216 - 토큰 유효 체크 (백단에서 체크)
const tokenVerifyFromServer = () => { // token verify
  get("/api/etc/token/validation", null, (response) => {
    if (response.messageCode === 200) return true; // console.log("정상이구만");
    else if (response.messageCode === 401) {
      window.location.href = "/main/login"; // SessionStorage에 저장된 토근이 없는 상태

      return;
    } else if (response.messageCode === 444) { // 토큰이 만료가 된 상태
      put("/api/etc/token/refresh", { refresh: nvl(adminSession?.refreshToken) }, (res) => { // refresh token 으로 access token 재발급
        // console.log(res)

        if (res.messageCode === 200) { // 재발급 된 토근을 로컬에 저장
          SessionStorage.clearItem("adminSession")
          SessionStorage.setItem("adminSession", "accessToken", res.data.accessToken)
          SessionStorage.setItem("adminSession", "refreshToken", res.data.refreshToken)

          return true;
        } else if (res.messageCode === 401) {
          window.location.href = "/main/login"; // SessionStorage에 저장된 토근이 없는 상태

          return;
        }
      });
    } else {
      window.location.href = "/main/login";

      return;
    }

    return false
  });
}

// added by psk 20230322 - 토큰 유효 체크 (로컬에서 체크)
const tokenVerify = (pathname) => {
  const managerToken = tokenDecoder()

  if (managerToken != null && nvlNumber(managerToken?.seq) > 0) {
    // console.log("만료시간 체크", moment(managerToken?.exp * 1000).format("YYYY-MM-DD HH:mm:ss"), moment(managerToken?.exp * 1000).diff(moment()))

    if (moment(managerToken?.exp * 1000).diff(moment()) < 0) {
      // console.log("만료된 상태");

      put("/api/etc/token/refresh", { refresh: nvl(adminSession?.refreshToken) }, (res) => { // refresh token 으로 access token 재발급
        // console.log(res)

        if (res.messageCode === 200) { // 재발급된 토근을 로컬에 저장
          SessionStorage.clearItem("adminSession")
          SessionStorage.setItem("adminSession", "accessToken", res.data.accessToken)
          SessionStorage.setItem("adminSession", "refreshToken", res.data.refreshToken)

          if (nvl(pathname) !== "") {
            window.location.href = pathname;
            return;
          }

          return true;
        }
      })
    } else return true; // accessToken 이 유효한 상태
  }

  return false;
}

const tokenDecoder = () => {
  if (nvl(adminSession?.accessToken) === "") return null;

  return jwt_decode(adminSession?.accessToken);
}

export function waitFor(promises, callback) {
  return axios.all(promises).then(callback);
}

const request = {
  get,
  post,
  put,
  patch,
  del,
  getBase,
  processError,
  waitFor,
  getRedirectUrl,
  postMultipart,
  tokenVerify,
  tokenVerifyFromServer,
  tokenDecoder,
  currentTimeStamp,
  jsonpFunc
};

export default request;
